export default (api) => ({
    uploadDataset: ({ processId, params }) => api.post(`/datasets/${processId}/assistant/uploadfile`, params),
    getHistory: ({ processId, params }) => api.post(`/datasets/${processId}/assistant/history`, params),
    startThread: ({ processId, params }) => api.post(`/datasets/${processId}/assistant/initthread`, params),
    sendMessage: ({ processId, text, params }) => api.post(`/datasets/${processId}/assistant/sendMessage/${text}`, params),
    substituteFile: ({ processId, params }) => api.post(`/datasets/${processId}/assistant/substituteFile`, params),
    restartThread: ({ processId, params }) => api.post(`/datasets/${processId}/assistant/restartThread`, params),
    uploadFileAndInitThread: ({ processId, params }) => api.post(`/datasets/${processId}/assistant/uploadFileAndInitThread`, params),
})
